
import { useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { v4 as uuidv4 } from "uuid";

import { Button } from "react-bootstrap";

import icon from "../../../assets/static/images/secciones/abogados.png";
import { Tabla } from "../../../components/Table/Table";
import { Filter } from "../../../components/Filter";
import { useUser } from "../../../hooks/useUser";
import { AbogadoService } from "../../../_services/abogados.service";
import { Eye, Settings } from "react-feather";
import Evaluaciones from "./Components/Evaluaciones";

import { useDispatch } from "react-redux";
import { getTipoEtapas } from "../../../redux/Sections/Estados/actions";
import { actuacionesService } from "../../../_services/actuaciones.service";
import { setLoading } from "../../../redux/Loading/actions";
import moment from "moment";
import { evaluacionesService } from "../../../_services/evaluaciones.service";
import Evaluacion from "./Components/Evaluacion";
import ArrowBack from "../../../components/ArrowBack";
// import { evaluacionesService } from "../../../_services/evaluaciones.service";

const EvaluacionAbogados = () => {
  const user = useUser();
  const dispatch = useDispatch();

  const [showFilter, setShowFilter] = useState(true);
  const [showTable, setShowTable] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [show, setShow] = useState(false);
  const [showConfig, setShowConfig] = useState(false);
  const [data, setData] = useState("");

  useEffect(() => {
    getData();
  }, [user]);

  const getData = async (data) => {
    dispatch(setLoading(true));
    let props = { ...data, baja: 0 };

    if (user.abogado !== "A00") {
      props.codexterno = user.abogado;
    }
    let res = await AbogadoService.searchAbogados(props);

    const actuacionesRes = await actuacionesService.lastActuacion();
    const evaluacionesRes = await evaluacionesService.lastByAbogado();
    let promises = res.map(async (abogado) => {
      const actuacion = actuacionesRes.find((e) => e.abogado === abogado.codexterno);
      const evaluacion = evaluacionesRes.find((e) => e.abogado === abogado.codexterno);

      return { ...abogado, evaluacion, actuacion };
    });

    const actuaciones = await Promise.all(promises);

    dispatch(getTipoEtapas(3));

    setDataList(actuaciones);

    dispatch(setLoading(false));

    return actuaciones;
  };

  const handleShow = (e) => {
    setData(e);
    setShow(true);
  };
  const handleClose = () => {
    setData("");
    getData();
    setShow(false);
  };

  const handleShowConfig = (e) => {
    setData(e);
    setShowConfig(true);
  };
  const handleCloseConfig = () => {
    setShowConfig(false);
  };

  const columns = [
    {
      title: "APELLIDO Y NOMBRE",
      dataIndex: "apellido_nombre",
    },
    {
      title: "DNI",
      dataIndex: "nrodni",
    },
    {
      title: "CODEXTERNO",
      dataIndex: "codexterno",
    },
    {
      title: "MATRÍCULA",
      dataIndex: "matricula",
    },
    {
      title: "FECHA ÚLTIMA ACTUACIÓN",
      dataIndex: "ultima_fecha",
    },
    {
      title: "FECHA ÚLTIMA EVALUACIÓN",
      dataIndex: "ultima_evaluacion",
    },
    {
      title: "SCORING",
      dataIndex: "scoring",
      render: (a, row) => {
        if (!row?.evaluacion) return null;

        return (
          <div className={`text-center badge-${row?.evaluacion.resultado?.toLowerCase() || ""}`}>
            {row?.evaluacion?.resultado?.toUpperCase()}
          </div>
        );
      },
    },
    {
      title: "ACCIONES",
      dataIndex: "accion",
      render: (a, row) => {
        return (
          <div className="d-flex">
            <Eye
              className="mx-2 action-table"
              onClick={() => handleShow(row)}
            />
            <Settings
              className="mx-2 action-table"
              onClick={() => handleShowConfig(row)}
            />
          </div>
        );
      },
    },
  ];

  const formatData = (arrayData) => {
    try {
      if (!arrayData || !arrayData.length) return [];
      return arrayData.map(item => {
        return {
          ...item,
          apellido_nombre: `${item?.apellido?.toUpperCase()}, ${item?.nombre}`,
          baja: item?.baja ? "SI" : "NO",
          ultima_fecha: item?.actuacion ? moment(item?.actuacion.fecha).format("DD/MM/YYYY") : "",
          ultima_evaluacion: item?.evaluacion ? moment(item?.evaluacion.fecha).format("DD/MM/YYYY") : "",
          uuid: uuidv4(),
        };
      });
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };

  const fields = useMemo(
    () => [
      [
        {
          label: "Apellido",
          type: "text",
          name: "apellido",
        },
        {
          label: "Nombre",
          type: "text",
          name: "nombre",
        },
        {
          label: "DNI",
          type: "text",
          name: "dni",
        },
        {
          label: "Codexterno",
          type: "text",
          name: "codexterno",
        },
      ],
      [
        // {
        //   label: "Estado",
        //   type: "select",
        //   name: "estado",
        //   options: [
        //     {
        //       value: "ACTIVO",
        //       label: "ACTIVO"
        //     },
        //     {
        //       value: "INACTIVO",
        //       label: "INACTIVO"
        //     }
        //   ],
        // },
        {
          label: "Scoring",
          type: "number",
          name: "scoring",
        },
      ]
    ],
    []
  );

  return (
    <div className="section-content inbox-section">
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="bandejaentrada" />
        <span>Scoring abogados externos</span>
      </div>
      <ArrowBack />
      
      {user.abogado === "A00" && (
        <>
          <div className="buttons-filter">
            <h3 className="mr-3">Filtros:</h3>
            <div className="button-filter">
              {showFilter ? (
                <Button
                  variant="danger"
                  onClick={() => setShowFilter(false)}
                  className="danger-button d-flex align-items-center"
                  style={{ maxWidth: 105 }}
                >
                  <FontAwesomeIcon icon={faArrowDown} size="1x" /><span className="ml-2">Ocultar</span>
                </Button>
              )
                : (
                  <Button
                    onClick={() => setShowFilter(true)}
                    className="custom-button d-flex align-items-center"
                    style={{ maxWidth: 105 }}
                  ><FontAwesomeIcon icon={faArrowUp} size="1x" /><span className="ml-2">Mostrar</span>
                  </Button>
                )}
            </div>
          </div>
          <div className="section-filter">
            <Filter
              showFilter={showFilter}
              setShowFilter={setShowFilter}
              style={{ marginBottom: "30px" }}
              action={getData}
              setShowTable={setShowTable}
              setData={setDataList}
              fields={fields}
            />
          </div>
        </>
      )}


      {showTable ? (
        <>
          {user.abogado === "A00" && <div className="mb-3 fw-600" style={{ width: "80%", textAlign: "start" }}>LISTA DE ABOGADOS</div>}
          <div className="data-content">
            <div className="data-table section-table">
              <Tabla dataList={formatData(dataList)} columns={columns} />
            </div>
          </div>
        </>
      ) : null}
      {show && <Evaluaciones show={show} handleClose={handleClose} data={data} />}
      {showConfig && <Evaluacion show={showConfig} handleClose={handleCloseConfig} data={data} />}
    </div>
  );
};


export default EvaluacionAbogados;